const formatValue = (value, prefix, postfix, defaultValue) => (
  value != null ? `${prefix || ''}${value}${postfix || ''}` : defaultValue
);

export default formatValue;
